import { React, useEffect, useState, useRef } from "react";
import reports from "./data.json";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useHistory } from "react-router-dom";
import { models, Report, Embed, service, Page } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { PostData } from "../../Services/PostData";
import LoadingSpinner from "../../Assets/LoadingSpinner/LoadingSpinner";
import LogoBlack from "../../Assets/Images/logo_black.png";

import "./NavBI.css";

export default function NavBI() {
  const [data, setData] = useState([]);

  const [reportParams, setReportParams] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingReport, setIsLoadingReport] = useState(true);
  const funcion = {};
  const home = [];
  const [hash, setHash] = useState("");
  const [appState, setAppState] = useState(false);
  const [navData, setNavData] = useState([]);

  document.title = "PowerBI";
  const routerHistory = useHistory();

  useEffect(() => {
    // NAVBAR request
    funcion.Function = "PBINav";
    funcion.RequestType = "Request";
    funcion.usrToken = localStorage.getItem("usrToken");

    PostData("POST", funcion).then((result) => {
      setNavData(result.data);
      setIsLoading(false);
    }, []);
    // Report load

    let curpath = window.location.pathname.substring(17, 90).split("/");
    let curreport = curpath[0];
    let curpage = curpath[1];

    funcion.Function = "NavReport";
    funcion.RequestType = "Request";
    funcion.usrToken = localStorage.getItem("usrToken");
    funcion.Report = window.location.hash;
    funcion.Report = curreport;
    funcion.Page = curpage;
    PostData("POST", funcion).then((result) => {
      setReportParams(result);
      setAppState(true);
      setHash(result.name);
      setIsLoadingReport(false);
    }, []);
  }, []);

  const handleSelect = (eventKey) => {
    let navigation = eventKey.split("/");
    let report = navigation[0];
    let page = navigation[1];

    let curpath = window.location.pathname.substring(17, 90).split("/");
    let curreport = curpath[0];
    let curpage = curpath[1];

    console.log("eventKey: " + eventKey);
    console.log("curreport: " + curreport);
    console.log("curpage: " + curpage);
    console.log("report: " + report);
    console.log("page: " + page);

    if (report != curreport) {
      setIsLoadingReport(true);
      funcion.Function = "NavReport";
      funcion.RequestType = "Request";
      funcion.usrToken = localStorage.getItem("usrToken");
      funcion.Report = window.location.hash;
      funcion.Report = report;
      funcion.Page = page;
      PostData("POST", funcion).then((result) => {
        setReportParams(result);
        setAppState(true);
        setHash(result.name);
        setIsLoadingReport(false);
      }, []);
    } else if (page != curpage) {
      report = reportParams;
      report.reportConfig["0"].pageName = page;
      setReportParams(report);
    }

    routerHistory.push(`/dashboard/NAVBI/${navigation[0]}/${navigation[1]}`);
  };

  return !isLoading && navData != null ? (
    <div className="navBI">
      <div className="navBIheader">
        <div
          className="navBI-img"
          style={{
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundImage: `url(${LogoBlack})`,
          }}
        />
        <Nav
          className="navBar"
          variant="pills"
          activeKey="3.1"
          onSelect={handleSelect}
        >
          {navData.map((item, index) => {
            // LEVEL 1

            return (
              <NavDropdown title={item.name} key={item.id}>
                {item.children.map((subitem, index) => {
                  if (
                    subitem.children !== undefined &&
                    subitem.children != null &&
                    subitem.visible == true
                  ) {
                    //LEVEL 2
                    return (
                      <NavDropdown
                        eventKey={subitem.id}
                        key={subitem.id}
                        title={subitem.name}
                      >
                        {subitem.children.map((subitem2, index) => {
                          if (
                            subitem2.children !== undefined &&
                            subitem2.visible == true &&
                            subitem2.children != null
                          ) {
                            //LEVEL 3
                            return (
                              <NavDropdown
                                eventKey={subitem2.id}
                                key={subitem2.id}
                                title={subitem2.name}
                              >
                                {subitem2.children.map((subitem3, index) => {
                                  return (
                                    <NavDropdown.Item
                                      eventKey={
                                        subitem3.report + "/" + subitem3.page
                                      }
                                    >
                                      {subitem3.name}
                                    </NavDropdown.Item>
                                  );
                                })}
                              </NavDropdown>
                            );
                          } else if (
                            subitem2.children !== undefined &&
                            subitem2.visible == false
                          ) {
                            //LEVEL 3
                            return (
                              <>
                                {subitem2.children.map((subitem3, index) => {
                                  return (
                                    <NavDropdown.Item
                                      eventKey={
                                        subitem3.report + "/" + subitem3.page
                                      }
                                    >
                                      {subitem3.name}
                                    </NavDropdown.Item>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                      </NavDropdown>
                    );
                  } else if (
                    subitem.children !== undefined &&
                    subitem.visible == false &&
                    subitem.children != null
                  ) {
                    return (
                      <>
                        {subitem.children.map((subitem2, index) => {
                          if (
                            subitem2.children !== undefined &&
                            subitem2.visible == true &&
                            subitem2.children != null
                          ) {
                            //LEVEL 3
                            return (
                              <NavDropdown
                                eventKey={subitem2.id}
                                key={subitem2.id}
                                title={subitem2.name}
                              >
                                {subitem2.children.map((subitem3, index) => {
                                  return (
                                    <NavDropdown.Item
                                      eventKey={
                                        subitem3.report + "/" + subitem3.page
                                      }
                                    >
                                      {subitem3.name}
                                    </NavDropdown.Item>
                                  );
                                })}
                              </NavDropdown>
                            );
                          } else if (
                            subitem2.children !== undefined &&
                            subitem2.visible == false
                          ) {
                            //LEVEL 3
                            return (
                              <>
                                {subitem2.children.map((subitem3, index) => {
                                  console.log(subitem3);
                                  return (
                                    <NavDropdown.Item
                                      eventKey={
                                        subitem3.report + "/" + subitem3.page
                                      }
                                    >
                                      {subitem3.name}
                                    </NavDropdown.Item>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  }
                })}
              </NavDropdown>
            );
          })}
        </Nav>
      </div>
      <div className="navBIreport">
        {isLoadingReport ? (
          <LoadingSpinner />
        ) : (
          <>
            {reportParams != null &&
              reportParams.embedType == "ServicePrincipal" && (
                <PowerBIEmbed
                  embedConfig={{
                    type: "report", // Supported types: report, dashboard, tile, visual and qna
                    id: reportParams.reportConfig["0"].reportId,
                    embedUrl: reportParams.reportConfig["0"].embedUrl,
                    accessToken: reportParams.accessToken,
                    tokenType: models.TokenType.Embed,
                    pageName: reportParams.reportConfig["0"].pageName,
                    settings: {
                      panes: {
                        filters: {
                          expanded: false,
                          visible: false,
                        },
                        pageNavigation: {
                          visible: JSON.parse(
                            reportParams.reportConfig[
                              "0"
                            ].pageNavigation.toLowerCase()
                          ),
                        },
                      },
                      background: models.BackgroundType.Transparent,
                    },
                  }}
                  eventHandlers={
                    new Map([
                      [
                        "loaded",
                        function () {
                          console.log("Report loaded");
                        },
                      ],
                      [
                        "rendered",
                        function () {
                          console.log("Report rendered");
                        },
                      ],
                      [
                        "error",
                        function (event) {
                          console.log(event.detail);
                        },
                      ],
                    ])
                  }
                  cssClassName={"report-style-class"}
                  getEmbeddedComponent={(embeddedReport) => {
                    window.report = embeddedReport;
                  }}
                />
              )}
            {reportParams != null && reportParams.embedType == "Secure" && (
              <iframe
                src={
                  "https://app.powerbi.com/reportEmbed?reportId=" +
                  reportParams.reportConfig["0"].reportId +
                  "&autoAuth=true&pageName=" +
                  reportParams.reportConfig["0"].pageName
                }
                frameBorder="0"
                allowFullScreen="true"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            )}
          </>
        )}
      </div>
    </div>
  ) : (
    <LoadingSpinner />
  );
}
